/* eslint-disable */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useCookies } from 'react-cookie'; // ✅ 1. เพิ่ม import useCookies

import AllDepartment from '../services/allDepartment';

import Alert from '../services/alert';

import AllWorkForce from '../services/allWorkForce';

import AllUsersAD from '../services/allUserAd';

import AllCountry from '../services/allCountrys';

import AllAmphures from '../services/allAmphures';

import AllTambons from '../services/allTambons';

import AllProvinces from '../services/allProvinces';

import AllReqEmployee from '../services/allReqEmployee';

import GetOrganizeList from '../services/getOrganizeList';

import AllBranch from '../services/allBranch';

import GetJobOpeningAll from '../services/getJobOpeningAll';

import GetCandidate from '../services/getCandidate';

import AllRecruit from '../services/allRecruit';

import AllCandidate from '../services/allCandidate';

import Spin from '../services/spin';

import Token from '../services/token';

import GetAllDoc from '../services/getAllDoc';

import GetPendingEvaluations from '../services/getPendingEvaluations';

import TestGetPendingEvaluations from '../services/testGetPendingEvaluations';

import GetSupervisorQuestions from '../services/getSupervisorQuestions';

import DocOther from '../services/docOther';

import Announcement from '../services/announcement';

import GetAllJobPosition from '../services/allPositions';

import DocType from '../services/docType';

import FolderInHr from '../services/folderInHr';

import GetEmployeeDocuments from '../services/getEmployeeDocuments';

import GetAllJobLevels from '../services/getAllJobLevels';

import GetAllEmployees from '../services/allEmployees';

import GetEmployeesForEvaluation from '../services/getEmployeesForEvaluation';

import Resignations from '../services/resignations';

import Assets from '../services/assets';
import AllEvaluationMappings from '../services/AllEvaluationMappings';
import AllEvaluationResults from '../services/AllEvaluationResults';
import AllKpis from '../services/AllKpis';
import AllBehaviors from '../services/AllBehaviors';

const DataContext = createContext();

export const useDataContext = () => {
  return useContext(DataContext);
};

export const DataProvider = ({ children }) => {
  // ✅ 2. เรียกใช้ cookies
  const [cookies] = useCookies(['session']);

  const [data, setData] = useState({
    // ... (state เดิมของคุณทั้งหมด ไม่ต้องแก้) ...
    dialogScore: false,
    department: [],
    alertIcon: '',
    alertTitle: '',
    alertText: '',
    alertFooter: '',
    alert: false,
    workforce: null,
    allBranch: [],
    getAllJobPosition: [],
    selectView: 'end',
    prepareEditWorkforce: [],
    allUsersAD: [],
    decodeToken: null,
    clearSession: false,
    getJobOpeningAll: [],
    allCountry: [],
    allProvinces: [],
    allAmphures: [],
    allTambons: [],
    fName: '',
    lName: '',
    phoneNumber: '',
    militaryStatus: '',
    gender: '',
    nationality: '',
    religion: '',
    weight: '',
    height: '',
    maritalStatus: '',
    lineId: '',
    country: '',
    currentAddress: '',
    province: '',
    district: '',
    subdistrict: '',
    postalCode: '',
    personalVehicle: '',
    day: '',
    month: '',
    year: '',
    getAllJobApplications: [],
    docOther: [],
    docType: [],
    spin: false,
    folderInHr: [],
    docExp: '',
    formDocExp: '',
    getPendingEvaluations: [],
    getSupervisorQuestions: [],
    getAllEmployees: [],
    getEmployeesForEvaluation: [],
    isResizing: false,
    getEmployeeDocuments: [],
    resignations: [],
    dialogSignup: false,
    selectedEmployee: 'pendingEva',
    workExperience: [],
    certificationTraining: [],
    languageSkills: [],
    expenseDate: [],
    generalAbility: {},
    evaluationMappings: [],
    evaluationResults: [],
    allKpis: [],
    allBehaviors: [],
    // เปิด/ปิด CookieConsent modal จาก trigger ภายนอก (account-popover) ในโหมด edit
    cookieSettingsOpen: false,
  });

  // ✅ 3. สร้างตัวแปรเช็คสถานะการ Login
  // ตรวจสอบว่ามี cookie session หรือมี decodeToken ใน state หรือไม่
  const isLoggedIn = !!cookies.session || !!data.decodeToken;

  return (
    <DataContext.Provider value={{ data, setData }}>
      <Alert />
      <Spin />
      <Token />
      {isLoggedIn && (
        <>
          <AllEvaluationMappings />
          <AllEvaluationResults />
          <AllKpis />
          <AllBehaviors />
          <Assets />
          <GetEmployeeDocuments />
          <GetAllJobLevels />
          <GetSupervisorQuestions />
          <Resignations />
          {/* <Score/> */}
          <GetEmployeesForEvaluation />
          <GetAllEmployees />
          <DocOther />
          <GetPendingEvaluations />
          <TestGetPendingEvaluations />
          <GetAllDoc />
          <Spin />
          <Token />
          <Announcement />
          <FolderInHr />
          <DocType />
          <GetOrganizeList />
          <AllCandidate />
          <GetCandidate />
          <AllRecruit />
          <GetAllJobPosition />
          <Alert />
          <AllDepartment />
          <AllCountry />
          <AllAmphures />
          <AllTambons />
          <AllProvinces />
          <AllUsersAD />
          <AllReqEmployee />
          <AllBranch />
          <GetJobOpeningAll />
          <AllWorkForce />
        </>
      )}

      {children}
    </DataContext.Provider>
  );
};
